/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/162-glass2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.893 2.809a.499.499 0 00-.393-.808h-11a.501.501 0 00-.393.808L7 9.037V15H5.5a.5.5 0 000 1h5a.5.5 0 000-1H9V9.037l4.893-6.228zM12.471 3L10.9 5H5.1L3.529 3h8.943z"/>'
  }
})
